import {mapMutations} from "vuex";

export default {
    data: () => {
        return {
            setDarkMode : false
        }
    },
    beforeMount() {
        if (this.setDarkMode) {
            this.enableDarkMode()
        } else {
            this.disableDarkMode()
        }
    },
    methods: {
        ...mapMutations('menu', [
            'enableDarkMode',
            'disableDarkMode'
        ]),
    }
}
